import { Navbar } from './modules/Navbar';

if(document.querySelector('[data-navbar]')) {
    new Navbar();
}

if(document.querySelector('[data-toggle]')) {
    (async () => {
        const { Toggler } = await import('./modules/Toggler');
        new Toggler();
    })();
}

if(document.querySelectorAll('[data-add-to-cart]')) {
    (async () => {
        const { Cart } = await import('./modules/Cart');
        new Cart();
    })();
}

if(document.querySelector('[data-ecommerce-view-item]')) {
    (async () => {
        const { ProductPageEcommerce } = await import('./modules/ProductPageEcommerce');
        new ProductPageEcommerce();
    })();
}

if(document.querySelector('.footer-logos-swiper')) {
    (async () => {
        const { FooterLogosSwiper } = await import('./modules/Swiper/FooterLogosSwiper');
        new FooterLogosSwiper('.footer-logos-swiper');
    })();
}

if(document.querySelector('.testimonials-swiper')) {
    (async () => {
        const { TestimonialsSwiper } = await import('./modules/Swiper/TestimonialsSwiper');
        TestimonialsSwiper.initAll();
    })();
}

if(document.querySelector('[data-fade-gallery]')) {
    (async () => {
        const { FadeGallery } = await import('./modules/FadeGallery');
        FadeGallery.initAll();
    })();
}

if(document.querySelector('.typewriter')) {
    (async () => {
        const { TypeWriter } = await import('./modules/TypeWriter/TypeWriter');
        new TypeWriter();
    })();
}

if(document.querySelector('[data-yt-iframe]')) {
    (async () => {
        const { YouTubeIframe } = await import('./modules/YouTubeIframe/YouTubeIframe');
        new YouTubeIframe();
    })();
}

if(document.querySelector('.wc-block-checkout')) {
    (async () => {
        const { Checkout } = await import('./modules/Checkout');
        new Checkout();
    })();
}

if(document.querySelector('.woocommerce-cart')) {
    (async () => {
        const { CartPage } = await import('./modules/CartPage');
        new CartPage();
    })();
}

if(document.querySelector('.wp-block-woocommerce-cart')) {
    (async () => {
        const { CartItem } = await import('./modules/CartItem');
        new CartItem();
    })();
}

if(document.querySelector('[data-countdown]')) {
    (async () => {
        const { Countdown } = await import('./modules/Countdown');
        new Countdown();
    })();
}